// DS: i11.2
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const OriginalBrush: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.54 9.409q.404.216.811.487a8.85 8.85 0 0 1 2.901 3.167l4.907-5.877c2.42-3.256-.929-5.532-3.2-3.284zM14.038 14.439c1.321 4.518-4.399 8.834-10.796 5.206-.34-.194-.316-.715.035-.886.744-.361 1.706-1.207 2.192-3.184.85-3.476 3.407-5.77 5.816-4.531 1.289.662 2.208 1.529 2.753 3.395"></path>
    </svg>
  </IconWrap>
);
OriginalBrush.displayName = 'OriginalBrush';

export default OriginalBrush;
